import { type CreateBlockData } from '@/lib/builder/types'

import type {
  LocationSelectSection,
  LocationSelectSectionCreate,
} from '../../../../types/FormBuilder.types'

export const createLocationSelectData = ({
  brandId,
  type,
}: CreateBlockData<LocationSelectSection>): LocationSelectSectionCreate => ({
  brandId,
  params: {
    label: 'Location',
    options: [],
    required: false,
  },
  type,
})
